var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"tablaLT1",class:_vm.dark_t?'dark':'',attrs:{"headers":_vm.headers,"items":_vm.items,"disable-pagination":"","hide-default-footer":""},scopedSlots:_vm._u([{key:"no-data",fn:function(){return [_c('v-icon',[_vm._v("warning")]),_vm._v("\n      Sin Información.\n  ")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }